import { render, staticRenderFns } from "./ModalGenerateArticles.vue?vue&type=template&id=7fcac2da"
import script from "./ModalGenerateArticles.vue?vue&type=script&lang=js"
export * from "./ModalGenerateArticles.vue?vue&type=script&lang=js"
import style0 from "./ModalGenerateArticles.vue?vue&type=style&index=0&id=7fcac2da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports